import PropTypes from 'prop-types';

import { formatsEnum, formatFullDate } from '../../utils/formatUtils';

import setBackgroundColor from './utils/recordHistoryUtils';
import CommentsHistory from './CommentsHistory';
import './RecordHistoryContainer.scss';

const RecordHistory = ({ historyData }) => (
  <ul className="list_container_history">
    {historyData?.map((record, index) => {
      const { accion, usuario, usuarioEmpresa, fecha, step, color, observacion } = record;
      const date = formatFullDate(fecha, formatsEnum.FORMAT_DATE_6);

      return (
        <li className="wrapper" key={`${index.toString()}-${record.id}`}>
          <div className="step_wrapper">
            <div
              className="step_circle"
              style={{
                borderColor: `${color}`
              }}
            >
              <div
                className="step_number"
                style={{
                  color: `${color}`
                }}
              >
                {step}
              </div>
            </div>
            {index !== historyData.length - 1 && <div className="step_line" />}
          </div>
          <div
            className="date_container"
            style={{
              backgroundColor: setBackgroundColor(color)
            }}
          >
            <span className="px-1">{date} hs</span>
          </div>
          <div className="action_wrapper">
            <div className="action">{accion}</div>
            {usuario && usuarioEmpresa && (
              <div className="user_wapper">
                <div>{usuario}</div>
                <span className="user_division"> | </span>
                <div>{usuarioEmpresa}</div>
              </div>
            )}
            {observacion && <CommentsHistory observacion={observacion} />}
          </div>
        </li>
      );
    })}
  </ul>
);

RecordHistory.propTypes = {
  historyData: PropTypes.arrayOf(
    PropTypes.shape({
      accion: PropTypes.string,
      usuario: PropTypes.string,
      usuarioEmpresa: PropTypes.string,
      fecha: PropTypes.string,
      step: PropTypes.number,
      color: PropTypes.string,
      observacion: PropTypes.string
    })
  ).isRequired
};

export default RecordHistory;
